import React from 'react';
import './Avatar.scss';

interface AvatarProps {
    image: string;
    type: 'name' | 'avatar';
}

const Avatar = ({image, type}: AvatarProps) => {
    return (
        <div className={`Avatar ${type}`}>
            <span>{image.slice(0, 1)}</span>
        </div>
    );
};

export default Avatar;
